import awsmobile from "./aws-exports";

const redirectSignInVar = () => {
  if (process.env.NODE_ENV === "development") {
    return `http://localhost:8000/employee/resources/`;
  }
  return `${process.env.GATSBY_REDIRECT_SIGNIN_URL}/employee/resources/`;
};

const awsConfig = {
  ...awsmobile,

  aws_cognito_identity_pool_id:
    "ap-southeast-1:153a0f10-4b0d-4062-b587-a6b966b305c2",

  oauth: {
    domain: awsmobile.oauth.domain,
    scope: [
      "email",
      "openid",
      "aws.cognito.signin.user.admin",
      "profile",
    ],
    redirectSignIn: redirectSignInVar(),
    redirectSignOut: `${process.env.GATSBY_REDIRECT_SIGNIN_URL}/user/login/`,
    responseType: "code",
  },
};

export default awsConfig;
